export enum ThumbnailType {
  Square = "正方形ビジュアル",
  LatestEpisode = "最新エピソードサムネ",
}
